import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
/* eslint-disable @atlaskit/design-system/no-nested-styles */
/* eslint-disable @repo/internal/styles/no-exported-styles */
/** @jsx jsx */
import { css } from '@emotion/react';
import { relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
import { N30A } from '@atlaskit/theme/colors';
import { fontSize as getFontSize,
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
gridSize as getGridSize } from '@atlaskit/theme/constants';
var fontSize = getFontSize();
var gridSize = getGridSize();
export var replaceSectionButtonNewStyles = css({
  marginLeft: "var(--ds-space-050, 4px)",
  marginRight: "var(--ds-space-050, 2px)"
});
export var replaceSectionButtonOldStyles = css({
  marginLeft: "var(--ds-space-050, 4px)"
});
export var ruleStyles = css({
  width: '100%',
  border: 'none',
  backgroundColor: "".concat("var(--ds-border, ".concat(N30A, ")")),
  margin: "var(--ds-space-050, 4px)".concat(" 0px"),
  height: '1px',
  borderRadius: '1px'
});
export var wrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
  '> *:not(#replace-hr-element)': {
    margin: "0px ".concat("var(--ds-space-050, 4px)")
  }
});
export var wrapperPaddingStyles = css({
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)")
});
export var sectionWrapperStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n\n  & > * {\n    display: inline-flex;\n    height: 32px;\n    flex: 0 0 auto;\n  }\n\n  & > [data-ds--text-field--container] {\n    display: flex;\n    flex: 1 1 auto;\n  }\n"])));
export var sectionWrapperStylesAlternate = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n\n  & > * {\n    height: unset;\n  }\n"])), "var(--ds-space-100, 8px)");
export var sectionWrapperJustified = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  font-size: ", ";\n"])), relativeFontSizeToBase16(14));
export var textFieldWrapper = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1 100%;\n  flex-wrap: wrap;\n\n  #find-text-field,\n  #replace-text-field {\n    height: ", "em;\n  }\n\n  label {\n    font-size: ", ";\n    line-height: ", "px;\n  }\n"])), gridSize * 4.5 / fontSize, relativeFontSizeToBase16(14), gridSize * 2);
export var afterInputSection = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n"])));
export var matchCaseSection = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n\n  button {\n    width: 20px;\n    height: 20px;\n  }\n"])), "var(--ds-space-100, 8px)");
export var nextPreviousItemStyles = css({
  padding: "0px ".concat("var(--ds-space-025, 2px)")
});
export var countStyles = css({
  color: "var(--ds-text-subtlest, #626F86)",
  fontSize: "".concat(relativeFontSizeToBase16(12)),
  flex: '0 0 auto',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: "var(--ds-space-050, 4px)",
  marginRight: "var(--ds-space-100, 8px)"
});
export var countStylesAlternateStyles = css({
  display: 'inline-flex',
  height: '32px'
});
export var countWrapperStyles = css({
  alignItems: 'center'
});
export var orderZeroStyles = css({
  order: '0',
  marginInline: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-025, 2px)")
});
export var orderZeroDeprecatedStyles = css({
  order: '0',
  marginInline: 0
});
export var orderOneStyles = css({
  order: '1'
});